import { AnalyticCircle } from "./CircleAnalytics";
import { InnerContainer } from "./CircleAnalyticsDisplayStyle";
import { useTheme } from "styled-components";
import { labels } from "../../DataConstants/CirclyAnalyticsConstants";
import { useAppSelector } from "../../Hooks/Hooks";
import { selectPercentages } from "../../Redux/Data/DataSlice";

export const CircleAnalyticsDisplay: React.FC = () => {
    const percentages = useAppSelector(selectPercentages);
    const theme = useTheme();

    return (
        <InnerContainer>
            {percentages
                ? percentages.map((percent: number, idx: number) => {
                      return (
                          <AnalyticCircle
                              xOffset={100}
                              yOffset={100}
                              percentage={percent === 0 ? 0.1 : percent}
                              label={labels[idx]}
                              labelFontSize={20}
                              animationTime={theme.animationTime.long}
                              gradientStart={theme.gradient.gradientStart}
                              gradientEnd={theme.gradient.gradientEnd}
                              key={idx}
                          />
                      );
                  })
                : ""}
        </InnerContainer>
    );
};
